import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { UtilsServices } from '../services/utilsServices';
import i18n from 'i18next';
import { toast } from "react-toastify";

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id: 1, "title": "Template1","text": "<h1><strong>Lorem ipsum</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>"},
    { id: 2, "title": "Template2", "text": "<h1><strong>Lorem ipsum 2</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>" },
];

export default class UtilsStore {    

    
  rootStore;
    vatSettings = [];
    expenseVatSettings = [];

    currencies = [];
    countryCurrencies = [];
    templates = [];
    templatesWithoutEventType = [];
    clients = [];
    projects = [];
    developers = [];
    devMonths = [];
    emailServer = {};
    costsExpensesCategories = [];
    exchangeRates = [];
  //template = {};

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          vatSettings: observable,
          expenseVatSettings: observable,
          getVATs: action,
          getExpenseVATs: action,

          currencies: observable,
          getCurrencies: action,
          countryCurrencies: observable,
          getCountryCurrencies:action,

          templates: observable,
          templatesWithoutEventType: observable,
          getTemplates: action,
          getTemplatesWithoutEventType: action,

          getClients: action,
          getProjects: action,
          getProjectsForValidator: action,
          getDevelopers: action,
          clients: observable,
          projects: observable,
          developers: observable,
          devMonths: observable,
          getMonthsForDev: action,
          updateEmailServer: action,
          getEmailServer: action,

          getCostsExpensesCategories: action,
          costsExpensesCategories: observable,

          getExchangeRates: action,
          exchangeRates:observable
         
      });
    }       

    getExchangeRates = async (year,month) => {
        try {
            const data = await UtilsServices.getExchangeRates(year,month); runInAction(() => { this.exchangeRates = data; });
        } catch (error) {
            runInAction(() => { this.exchangeRates = []; })
        }
    };

    getCostsExpensesCategories = async (devId) => {
        try {
            const data = await UtilsServices.getCostsExpenses({devId:devId}); runInAction(() => { this.costsExpensesCategories = data; });
        } catch (error) {
            runInAction(() => { this.costsExpensesCategories = []; })
        }
    };

    getVATs = async (id) => {
        try {
            const data = await UtilsServices.getTVAs();
            runInAction(() => { this.vatSettings = data;});
        } catch (error) {
            runInAction(() => { this.vatSettings = {};})
        }
    };

    getExpenseVATs = async (id) => {
        try {
            const data = await UtilsServices.getExpenseTVAs();
            runInAction(() => { this.expenseVatSettings = data; });
        } catch (error) {
            runInAction(() => { this.expenseVatSettings = {}; })
        }
    };
    getCurrencies = async (id) => {
        try {
            const data = await UtilsServices.getCurrencies();
            runInAction(() => { this.currencies = data; });
        } catch (error) {
            runInAction(() => { this.currencies = {}; })
        }
    };

    getCountryCurrencies = async (excludeLocal) => {
        try {            
            const data = await UtilsServices.getCountryCurrencies({ excludeLocal: excludeLocal ?? false });
            runInAction(() => { this.countryCurrencies = data; });
        } catch (error) {
            runInAction(() => { this.countryCurrencies = {}; })
        }
    };

    getTemplates = async (id) => {
        try {
            const data = await UtilsServices.getTemplates();
            runInAction(() => { this.templates = data; });
        } catch (error) {
            runInAction(() => { this.templates = {}; })
        }
    };

    getTemplatesWithoutEventType = async (id) => {
        try {
            const data = await UtilsServices.getTemplatesWithoutEventType();
            runInAction(() => { this.templatesWithoutEventType = data; });
        } catch (error) {
            runInAction(() => { this.templatesWithoutEventType = {}; })
        }
    };

    getClients = async (id) => {
        try { const data = await UtilsServices.getClients(); runInAction(() => { this.clients = data; });
        } catch (error) {
            runInAction(() => { this.clients = []; })
        }
    };

    getProjects = async (id) => {
        try {
            const data = await UtilsServices.getProjects(id); runInAction(() => { this.projects = data; });
        } catch (error) {
            runInAction(() => { this.projects = []; })
        }
    };

    getProjectsForValidator = async (id) => {
        try {
            const data = await UtilsServices.getProjectsForValidator(id); runInAction(() => { this.projects = data; });
        } catch (error) {
            runInAction(() => { this.projects = []; })
        }
    };        

    getDevelopers = async (id,includeDeleted) => {
        try {
            const data = await UtilsServices.getDevelopers(id, includeDeleted); runInAction(() => { this.developers = data; });
        } catch (error) {
            runInAction(() => { this.developers = []; })
        }
    };

    getMonthsForDev = async (projectId,devId) => {
        try {
            const data = await UtilsServices.getMonthsForDev(projectId, devId); runInAction(() => { this.devMonths = data; });
        } catch (error) {
            runInAction(() => { this.devMonths = []; })
        }
    };

    updateEmailServer = async (dto) => {
        try {
            const data = await UtilsServices.updateEmailServer(dto);
            runInAction(() => toast.success(i18n.t("emailSettingsUpdated")));
        } catch (error) {
            //runInAction(() => { this.devMonths = []; })
        }
    };

    getEmailServer = async () => {
        try {
            const data = await UtilsServices.getEmailServer();
            runInAction(() => { this.emailServer = data; });
        } catch (error) {
            runInAction(() => { this.devMonths = {}; })
        }
    };
}